import { render } from "./JournalOnline.vue?vue&type=template&id=19a3e162&scoped=true"
import script from "./JournalOnline.vue?vue&type=script&lang=js"
export * from "./JournalOnline.vue?vue&type=script&lang=js"

import "./JournalOnline.vue?vue&type=style&index=0&id=19a3e162&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a3e162"]])

export default __exports__